/**
 * @param {unknown} unwrapped
 * @returns {unknown}
 */
export function asPosterInner(unwrapped) {
  if (unwrapped == null) return unwrapped;
  if (typeof unwrapped === "object" && "response" in unwrapped) {
    return unwrapped.response;
  }
  return unwrapped;
}

/**
 * @param {unknown} x
 * @returns {any[]}
 */
export function asArray(x) {
  if (x == null) return [];
  if (Array.isArray(x)) return x;
  if (typeof x === "object") {
    if (Array.isArray(/** @type {any} */(x).data)) return /** @type {any[]} */ (x).data;
  }
  return [];
}
